import React from 'react';
import LegalPage from './LegalPage';

const TermsAndConditions = () => (
  <LegalPage title="Terms and Conditions" updated="23 June 2026">
    <p>Welcome to ContextJet AI.</p>
    <p>
      These Terms and Conditions govern the use of our website, services,
      proposals, invoices, and client engagements. By accessing our website or
      engaging us for services, you agree to these Terms.
    </p>

    <h2>1. Business Information</h2>
    <p>
      ContextJet AI is the business/brand name used for providing software
      development, AI development, NLP solutions, automation systems, and IT
      consulting services.
    </p>
    <ul>
      <li>Legal entity: ContextJetAi Services LLP</li>
      <li>Registered country: India</li>
      <li>Email: takeoff@contextjetai.services</li>
      <li>Website: https://www.contextjetai.services</li>
    </ul>

    <h2>2. Services</h2>
    <p>We provide custom software and technology services, including but not limited to:</p>
    <ul>
      <li>AI application development</li>
      <li>NLP and language model solutions</li>
      <li>Automation systems</li>
      <li>Web application development</li>
      <li>Backend and API development</li>
      <li>Data processing workflows</li>
      <li>Software consulting</li>
      <li>Technical implementation and support</li>
    </ul>
    <p>
      The exact scope, deliverables, timelines, and pricing for each project are
      defined in the relevant proposal, statement of work, invoice, or written
      agreement shared with the client.
    </p>

    <h2>3. Custom Project Scope</h2>
    <p>
      All services are provided based on agreed project requirements. Any work
      outside the agreed scope may require a separate quotation, revised
      timeline, or additional payment.
    </p>

    <h2>4. Pricing and Payments</h2>
    <p>
      Our services are custom-priced based on project scope, complexity,
      estimated effort, timelines, integrations, and support requirements.
    </p>
    <p>
      Payments may be accepted through bank transfer, international bank
      transfer, Razorpay, or other approved payment methods.
    </p>
    <p>
      Unless otherwise stated in writing, payments must be made according to the
      invoice or proposal shared with the client.
    </p>

    <h2>5. Taxes</h2>
    <p>
      Applicable taxes, if any, will be charged as per Indian laws and the
      nature of the transaction. For eligible export of services, invoices may
      be issued as zero-rated export invoices subject to applicable compliance
      requirements.
    </p>

    <h2>6. Delivery of Services</h2>
    <p>Our services are delivered digitally. There is no physical shipping involved.</p>
    <p>
      Deliverables may be shared through email, cloud repositories, project
      management tools, deployment environments, or other mutually agreed
      digital channels.
    </p>
    <p>
      Delivery timelines depend on project scope, client approvals, access to
      required information, and timely payments.
    </p>

    <h2>7. Client Responsibilities</h2>
    <p>
      The client agrees to provide accurate information, timely approvals,
      required access credentials, project requirements, content, data, and
      feedback required to complete the work.
    </p>
    <p>
      Delays in providing required information or approvals may affect the
      project timeline.
    </p>

    <h2>8. Intellectual Property</h2>
    <p>
      Unless otherwise agreed in writing, ownership of final paid deliverables
      may be transferred to the client after full payment is received.
    </p>
    <p>
      ContextJet AI may retain ownership of pre-existing tools, frameworks,
      templates, libraries, know-how, reusable components, internal processes,
      and generic technical knowledge used in the project.
    </p>

    <h2>9. Confidentiality</h2>
    <p>
      We treat client information, business data, project details, and
      credentials as confidential. We do not intentionally disclose confidential
      client information to third parties except where required for service
      delivery, legal compliance, or with client approval.
    </p>

    <h2>10. Third-Party Services</h2>
    <p>
      Some projects may involve third-party tools, APIs, hosting providers, AI
      models, payment gateways, cloud services, or software platforms. The
      client may be responsible for separate third-party costs, subscriptions,
      API usage charges, or licenses unless otherwise agreed.
    </p>

    <h2>11. No Guarantee of Specific Business Results</h2>
    <p>
      We aim to provide high-quality software and consulting services. However,
      we do not guarantee specific revenue, profit, ranking, user adoption,
      business outcome, or performance result unless explicitly agreed in
      writing.
    </p>

    <h2>12. Limitation of Liability</h2>
    <p>
      To the maximum extent permitted by law, our liability for any claim
      related to our services is limited to the amount paid by the client for
      the specific service giving rise to the claim.
    </p>

    <h2>13. Termination</h2>
    <p>
      Either party may terminate a project as per the terms agreed in the
      proposal, invoice, or written agreement. Work completed until the date of
      termination may be billed and payable.
    </p>

    <h2>14. Governing Law</h2>
    <p>
      These Terms are governed by the laws of India. Any disputes shall be
      subject to the exclusive jurisdiction of competent courts in India.
    </p>

    <h2>15. Contact</h2>
    <p>For any questions about these Terms, please contact:</p>
    <ul>
      <li>Email: takeoff@contextjetai.services</li>
      <li>Website: https://www.contextjetai.services</li>
    </ul>
  </LegalPage>
);

export default TermsAndConditions;
